import HttpRequest from'../../../http/index.js';import {PRODUCT_CHAIN_PATH}from'@monorepo/shared';/*
 * @Author: 赵泽文
 * @Date: 2022-02-27 09:50:21
 * @LastEditors: 赵泽文
 * @LastEditTime: 2026-03-17 13:57:01
 * @Description: 门店接口
 */
/** 获取门店列表 */
const getLocationShopsList = (data, isReturnAxiosError) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations.json`,
        data,
        options: {
            isReturnAxiosError,
        },
    });
};
/** 通过id读取门店数量 */
const getLocationCountById = (params) => HttpRequest({
    url: `${PRODUCT_CHAIN_PATH}/ship_nets/count_by_out_location_id.json`,
    params,
});
/** 通过id读取门店 */
const readLocationShop = (locationId) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/${locationId}.json`,
    });
};
/** 更新门店信息 */
const updateLocation = (locationId, data) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/${locationId}.json`,
        method: 'PUT',
        data,
    });
};
/** 账号门店选择列表 */
const listLocationById = (data) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/list_by_account_id.json`,
        data,
    });
};
/** 查询配送中心可以配货的门店 */
const getLocationListByDistCenter = (locationId, chain_professional_is, params) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/list_can_distribution/${locationId}.json`,
        method: 'GET',
        data: { chain_professional_is, ...(params || {}) },
    });
};
/** 读取门店对应的配送中心 */
const getDistCenterByLocation = (locationId, chain_professional_is) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/distribution_center/${locationId}.json`,
        method: 'GET',
        data: { chain_professional_is },
    });
};
/** 读取门店对应的收货门店 */
const getDirectTransferByLocation = (locationId, chain_professional_is) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/ship_nets/${locationId}/locations_on_same_distribution_center.json`,
        method: 'GET',
        data: { chain_professional_is },
    });
};
/** 选择门店(从mars进入应用) */
const chooseByAccountIdFromMars = (data) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/choose_by_account_id_from_mars.json`,
        method: 'GET',
        data,
    });
};
/** 查询普通门店(配送网络专用) */
const getLocationShopsListForShipNet = (data) => {
    //TODO:nhsoft.chenlh mars暂不支持门店排序
    delete data.sort_order;
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/ship_net.json`,
        method: 'GET',
        data,
    });
};
/** 查询读取总部 */
const getHeadquarters = () => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/headquarters.json`,
        method: 'GET',
    });
};
/** 配送中心视角下返回当前门店和上级配送中心 */
const getCurrentAndParentDistribution = (data) => {
    return HttpRequest({
        url: `${PRODUCT_CHAIN_PATH}/locations/list_current_and_parent_distribution.json`,
        method: 'GET',
        data,
    });
};export{chooseByAccountIdFromMars,getCurrentAndParentDistribution,getDirectTransferByLocation,getDistCenterByLocation,getHeadquarters,getLocationCountById,getLocationListByDistCenter,getLocationShopsList,getLocationShopsListForShipNet,listLocationById,readLocationShop,updateLocation};//# sourceMappingURL=locationShops.service.js.map
